import { EyeCatcher } from "./EyeCatcher";
import { Call } from "./Call";
import { Header } from "../Header";

import {
  StyledContainer,
  HeaderContainer,
  EyeCatcherContainer,
  CallContainer,
} from "./styles";

export function Jumbo({ onAction, links, socialLinks }) {
  return (
    <StyledContainer>
      <HeaderContainer>
        <Header links={links} socialLinks={socialLinks} />
      </HeaderContainer>
      <EyeCatcherContainer>
        <EyeCatcher />
      </EyeCatcherContainer>
      <CallContainer>
        <Call onAction={onAction} />
      </CallContainer>
    </StyledContainer>
  );
}
